module.exports = __webpack_public_path__ + "6fe6e076d9928ca834ffea44c382ed60.svg";